import actions from './actions'
import languageConfig from './config';

const initState = {
  language: languageConfig.getInitialLanguage(),
};

export default function languageReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_LANGUAGE:
      return {
        ...state,
        language: action.language,
      };
    case actions.RESET_LANGUAGE:
      return {
        ...state,
        language: languageConfig.defaultLanguage,
      };
    default:
      return state;
  }
}
